<template>
  <component class="fullwidth" :is="taskComponent" v-bind:step="step" :key="step" />
</template>

<script>
const components = {
  quiz: 'Quiz',
  submit: 'Submit',
  word_puzzle: 'WordPuzzle'
}
export default {
  computed: {
    assignment() {
      return this.$store.state.assignment
    },

    taskComponent() {
      if (!this.assignment || !this.assignment.task) {
        return null
      }

      return () => import(`@/components/assignments/${components[this.assignment.task.type]}`)
    },

    step () {
      return parseInt(this.$route.params.step)
    }
  }
}
</script>
<style>
  .fullwidth {
    width: 100%;
  }
</style>
